import { RequestExecutor } from "../../transport";
import { ExportersEndpoint } from "./exporters";
import { ExporterJobsEndpoint } from "./jobs";
import { PipelinesEndpoint } from "./pipelines";

export class CodegenEndpoint {
  readonly exporters: ExportersEndpoint;
  readonly pipelines: PipelinesEndpoint;
  readonly jobs: ExporterJobsEndpoint;

  constructor(private readonly requestExecutor: RequestExecutor) {
    this.pipelines = new PipelinesEndpoint(requestExecutor);
    this.exporters = new ExportersEndpoint(requestExecutor);
    this.jobs = new ExporterJobsEndpoint(requestExecutor);
  }
}
